import { AlertCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export function AccountSuspendedGate() {
  const { signOut } = useAuth();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#111111]">
      <div className="bg-[#1A1F26] rounded-xl w-full max-w-md mx-4">
        <div className="flex items-center gap-3 p-6 border-b border-white/[0.06]">
          <AlertCircle className="text-red-400" size={24} />
          <h2 className="text-xl font-semibold text-white">Account Closed</h2>
        </div>
        <div className="p-6">
          <p className="text-slate-300 mb-2">
            Your account has been closed.
          </p>
          <p className="text-slate-400 text-sm mb-6">
            If you believe this is a mistake, please contact support for assistance.
          </p>
          <button
            onClick={() => signOut()}
            className="w-full px-4 py-3 bg-[#2A2F36] hover:bg-[#3A3F46] text-slate-300 rounded-lg transition-colors font-medium"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
